export type ILoadDataEntryChild = (button: IjQueryElmOrHtmlElm) => void;

export function _loadDataEntryChild(button: IjQueryElmOrHtmlElm): void {
  const $button = $(button);
  const state = $button.attr('aria-expanded') === 'true';
  const $icon = $button.find('> span');
  const iconClass = state ? 'fa fa-plus' : 'fa fa-minus';
  const loadUrl = $button.data('load-url');
  const dataLoaded = !!$button.data('loaded');
  const target = $button.attr('href') as string;
  const $target = $(target);
  const $panelBody = $target.find('.panel-body');
  // Already open, just close it
  if (state) {
    $target.collapse('hide');
    $icon.removeClass().addClass(iconClass);
  } else if (dataLoaded) {
    // Data already loaded inside tab
    $target.collapse('show');
    $icon.removeClass().addClass(iconClass);
  } else {
    // Spin icon while data is loading
    $icon.removeClass().addClass('fa fa-refresh fa-spin');
    $.get(loadUrl, (data) => {
      $panelBody.empty().html(data);
      $button.removeData('loaded').attr('data-loaded', 'true');
      $target.collapse('show');
      $icon.removeClass().addClass(iconClass);
    });
  }
}
